import * as React from 'react'
import ModTemplateBlockList from "./templates/ModTemplateBlockList";

export default class Mod404 extends ModTemplateBlockList {

}
